import { render, staticRenderFns } from "./CourseDetails.vue?vue&type=template&id=eeb3f8ce&"
import script from "./CourseDetails.vue?vue&type=script&lang=js&"
export * from "./CourseDetails.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./CourseDetails.vue?vue&type=style&index=0&id=eeb3f8ce&prod&lang=stylus&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports